import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn.js";
import DateColumn from "@isceco/widget-library2/basic-elements/List/column/DateColumn.js";
import GenericColumn from "@isceco/widget-library2/basic-elements/List/column/GenericColumn.js";
import ButtonCell from "@isceco/widget-library2/basic-elements/List/cell/ButtonCell";
import AuthorizationFilter from "../Authorization/AuthorizationFilter";

export default class GPZVVEinladungColumns {

  static getColumns(acceptCallback, archiveCallback) {
    const roles = new AuthorizationFilter().roles
    if (roles.GP_SUPERUSER) {
      return [
        GPZVVEinladungColumns.NAME_COLUMN(),
        GPZVVEinladungColumns.INVITED_BY_COLUMN(),
        GPZVVEinladungColumns.INVITATION_DATE_COLUMN(),
        GPZVVEinladungColumns.ACCEPT_COLUMN(acceptCallback),
        GPZVVEinladungColumns.REJECT_COLUMN(archiveCallback)
      ]
    } else {
      return [
        GPZVVEinladungColumns.NAME_COLUMN(),
        GPZVVEinladungColumns.INVITED_BY_COLUMN(),
        GPZVVEinladungColumns.INVITATION_DATE_COLUMN(),
      ]
    }
  }

  static NAME_COLUMN() {
    return new StringColumn({
      key: 'name',
      text: 'gp.table.header.name'
    })
  }

  static INVITED_BY_COLUMN() {
    return new StringColumn({
      key: 'invitedBy',
      text: 'gp.table.header.invitedBy'
    })
  }

  static INVITATION_DATE_COLUMN() {
    return new DateColumn({
      key: 'createdAt',
      text: 'gp.table.header.createdAt'
    })
  }

  static ACCEPT_COLUMN(acceptCallback) {
    return new GenericColumn({
      weight: 0,
      align: 'right',
      cell: new ButtonCell({
        icon: 'check',
        variant: 'success',
        text: 'gp.table.accept',
        callback: row => acceptCallback(row),
        disabled: row => row.zvv.isAktiveKontingentierung
      })
    })
  }

  static REJECT_COLUMN(archiveCallback) {
    return new GenericColumn({
      weight: 0,
      align: 'right',
      cell: new ButtonCell({
        icon: 'times',
        variant: 'danger',
        text: 'gp.table.decline',
        callback: row => archiveCallback(row),
        disabled: row => row.zvv.isAktiveKontingentierung
      })
    })
  }
}
